import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../../DOM/form/label/LABEL.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
import INPUTDATETIME from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTDATETIME.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
// Model Structure
export const formInputDateTimeAttr = makeAttrStruct([
    ['class']
]);
export const formInputDateTimeData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formInputDateTimeModel = makeStruct([
    ['attributes', formInputDateTimeAttr],
    ['data', formInputDateTimeData]
]);
// Simplified Model
export function formInputDateTime(label, field, message, buttons) {
    return {
        attributes: formInputDateTimeAttr(),
        data: formInputDateTimeData(label, field, message, buttons)
    };
}
/** Represents an Input[type=datetime] for a Form */
export default class FORMINPUTDATETIME extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
    }
    createField(model) {
        return new INPUTDATETIME(this, model);
    }
}
